const nakiNigunContentType = {
    artists: 0,
    albums: 1,
};

export default nakiNigunContentType;
